import { render, staticRenderFns } from "./CustomerVisits.vue?vue&type=template&id=28d52e62"
import script from "./CustomerVisits.vue?vue&type=script&lang=js"
export * from "./CustomerVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports